import { decodeHtmlEntitiesPlain } from './decode-html-entities-plain';

/**
 * Get metadata fields from `<head>` meta tags.
 */
export const getMetadataFieldValue = (field: string): string => {
  const meta = document.querySelector(`meta[name="${field}"]`);
  const content = meta?.getAttribute('content');

  if (!meta || !content) {
    return '';
  }

  return decodeHtmlEntitiesPlain(content);
};
